import { useEffect, useRef } from "react";

export function useBrowserBack(onBack: () => void) {
  const onBackRef = useRef(onBack);
  onBackRef.current = onBack;

  useEffect(() => {
    // Push a sentinel entry so the back button hits it before leaving this page.
    history.pushState(null, "", window.location.href);

    function handlePopState() {
      onBackRef.current();
    }

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
}
